import { getLocalAuthStorage } from 'utils/localStorage';
import { refreshAuthLogic } from '../config'; // ajuste o path se necessário
import * as Sentry from '@sentry/react';

const checkIfSessionExpired = async config => {
  const { token, expiresIn } = getLocalAuthStorage();
  if (config?.skipAuthRefresh) {
    return config;
  }

  if (!token || !expiresIn) return config;

  const now = Date.now();
  const expires = new Date(expiresIn).getTime();

  if (now >= expires) {
    try {
      await refreshAuthLogic({
        config,
        response: { status: 401 },
      });
    } catch (err) {
      // refreshAuthLogic já trata os casos terminais como efeito colateral (redirect
      // pro /logout). Sem este catch, a rejeição (que pode ser um objeto puro como
      // `{ status: 401 }`, não um Error — ver `failedRequest.response` em refreshAuthLogic)
      // subia sem tratamento por este interceptor de REQUEST, virando unhandled rejection
      // ou "[object Object]" no console/Sentry. Deixa a requisição original seguir — se
      // o token realmente estiver inválido, o backend responde 401 de verdade e o
      // interceptor de response cuida do refresh reativo normalmente.
      Sentry.logger.warn('checkIfSessionExpired: falha ao tentar refresh preventivo', { error: String(err) });
    }
  }

  return config;
};

export { checkIfSessionExpired };
